// 订单相关
// @ts-check
export default {
   'order.dingding.list.title': '合同列表',
   'order.dingding.column.contractDate': '合同日期',
   'order.dingding.column.contractDate_begin': '开始日期',
   'order.dingding.column.contractDate_end': '结束日期',
   'order.dingding.column.contractDate.placeholder': '请选择合同日期',
   'order.dingding.column.contractNo': '合同号',
   'order.dingding.column.contractNo.placeholder': '请输入合同号',
   'order.dingding.column.sale': '销售',
   'order.dingding.column.sale.placeholder': '请选择销售',
   'order.dingding.column.manager': '项目经理',
   'order.dingding.column.manager.placeholder': '请选择项目经理',
   'order.dingding.button.update': '从钉钉更新',
   'order.dingding.column.orderNo': '订单号',
   'order.dingding.column.amount': '金额',
   'order.collect.modal.title': '我的收藏',
   'order.collect.select.modal.title': '选择收藏',
   'order.collect.column.name': '收藏名',
   'order.collect.column.input.name': '请输入收藏名',
   'order.collect.column.stepName': '任务名',
   'order.collect.column.input.stepName': '请输入任务名',
   'order.collect.column.stepName.placeholder': '请输入任务名',
   'order.collect.column.noSpace': '收藏名/任务名不允许输入纯空格，且第一个字符不为空格',
   'order.collect.column.userName': '负责人',
   'order.collect.column.input.userName': '请选择负责人',
   'order.collect.column.type': '类型',
   'order.collect.column.cat': '分类',
   'order.collect.button.add': '新增收藏',
   'order.collect.button.nodeSet': '配置流程',
   'order.collect.column.sequence': '拖动排序',
   'order.dingding.column.update': '从钉钉更新',
   'order.frontConfig.modal.title': '前置任务配置',
   'order.service.select': '选择任务',
   'order.collect.type1': '服务',
   'order.collect.type2': '自定义',
   'order.collect.type3': '固定',
   'order.collect.search.inputHolder': '请输入收藏名/任务名/负责人',
   'order.collect.edit.tip': '请先保存当前编辑的内容',


   "order.list.orderDate": "下单日期",
   "order.list.startDate": "开始日期",
   "order.list.endDate": "结束日期",
   "order.list.contractDate": "合同日期",
   "order.list.customerName": "客户名",
   "order.list.sales": "销售",
   "order.list.projectManager": "项目经理",
   "order.list.projectManagerAll": "项目经理",
   "order.list.estimatedCompletionDate": "预计完成日期",
   "order.list.estimatedCompletionDateA": "预计完成日期",
   "order.list.selectDate": "请选择日期",
   "order.list.orderStatus": "订单状态",
   "order.list.status": "状态",
   "order.list.selectStatus": "请选择状态",
   "order.list.currency": "币种",
   "order.list.selectCurrency": "请选择币种",
   "order.list.orderType": "订单类型",
   "order.list.type": "类型",
   "order.list.selectOrderType": "请选择订单类型",
   "order.list.orderProcessingStatus": "订单办理状态",
   "order.list.processingStatus": "办理状态",
   "order.list.selectProcessingStatus": "请选择订单办理状态",
   "order.list.processor": "办理人员",
   "order.list.cancelOrder": "作废订单",
   "order.list.show": "显示",
   "order.list.hide": "不显示",
   "order.list.search": "查询",
   "order.list.reset": "重置",
   "order.list.addOrder": "新增订单",
   "order.list.view": "查看",
   "order.list.edit": "编辑",
   "order.list.process": "办理",
   "order.list.delete": "删除",
   "order.list.more": "更多",
   "order.list.assignTask": "分配任务",
   "order.list.receivePayment": "收款",
   "order.list.makePayment": "付款",
   "order.list.issueInvoice": "开票",
   "order.list.closeOrder": "关闭",
   "order.list.nullify": "作废",
   "order.list.copy": "复制",
   "order.hint": "请选择想要查询的筛选项",
   "order.list.operator": "操作者",
   "order.list.operation": "操作",
   "order.list.amount": "金额",
   "order.list.deleteTips": "确定要删除此项吗？",
   "order.list.activeTips": "确定要执行此操作吗",
   "order.list.basicInfo": "基本信息",
   "order.list.orderNumber": "订单编号",
   "order.list.enterOrderNumber": "请输入订单编号",
   "order.list.contractNumber": "合同编号",
   "order.list.enterContractNumber": "请输入合同编号",
   "order.list.contractSigningDate": "合同签署日",
   "order.list.selectContractSigningDate": "请选择合同签署日",
   "order.list.customerNumber": "客户编号",
   "order.list.enterCustomerNumber": "请输入客户编号",
   "order.list.orderAmount": "订单金额",
   "order.list.enterOrderAmount": "请输入订单金额",
   "order.list.shSales": "山海图销售",
   "order.list.contractTaxRate": "合同税率",
   "order.list.enterContractTaxRate": "请输入合同税率",
   "order.list.selectStartDate": "请选择开始日期",
   "order.list.estimatedCompletion": "预计完成",
   "order.list.selectEstimatedCompletionDate": "请选择预计完成日期",
   "order.list.exchangeRate": "汇率",
   "order.list.contractScanCopy": "双签合同",
   "order.list.serviceList": "服务清单",
   "order.list.add": "新增",
   "order.list.remark": "备注",
   "order.list.cancel": "取消",
   "order.list.save": "保存",
   "order.list.submit": "提交",
   "order.list.total": "合计",
   "order.list.totalReceiptAmount": "总收款金额",
   "order.list.totalServiceFee": "总服务费",
   "order.list.confirmCancellation": "确定作废吗？",
   "order.list.serialNumber": "序号",
   "order.list.receiptName": "收款名称",
   "order.list.productName": "产品名称",
   "order.list.receiptAccount": "收款账户",
   "order.list.receiptAmount": "收款金额",
   "order.list.serviceFee": "服务费",
   "order.list.receiptDate": "收款时间",
   "order.list.normal": "正常",
   "order.list.cancelled": "已作废",
   "order.list.description": "说明",
   "order.list.operationTime": "操作时间",
   "order.list.processingFlow": "办理流程",
   "order.list.fullyImplemented": "全部实现",
   "order.list.inProgress": "处理中",
   "order.list.completed": "已完成",
   "order.list.notProcessed": "未办理",
   "order.list.file": "文件",
   "order.list.email": "邮箱",
   "order.list.phoneNumber": "手机号",
   "order.list.invoiceInformation": "开票信息",
   "order.list.receiptInformation": "收款信息",
   "order.list.paymentInformation": "付款信息",
   "order.list.customerNotification": "客户通知",
   "order.list.step": "步骤",
   "order.list.workflowName": "流程名",
   "order.list.precedingTask": "前置任务",
   "order.list.unitPrice": "单价",
   "order.list.discount": "优惠",
   "order.list.totalIncludingTax": "含税总额",
   "order.list.quantity": "数量",
   "order.list.responsiblePerson": "负责人",
   "order.list.duration": "工期",
   "order.list.estimatedCompletionTime": "预计完成日期",
   "order.list.node": "节点",
   "order.list.nodeName": "节点名称",
   "order.list.durationWorkingDays": "工期(工作日)",
   "order.list.maxdurationWorkingDays": "最大工期(工作日)",
   "order.list.processingTime": "办理时间",
   "order.list.progressDescription": "进展说明",
   "order.list.company": "公司",
   "order.list.registeredEmail": "注册邮箱",
   "order.list.inputRemark": "请输入备注",
   "order.list.paymentTime": "付款时间",
   "order.list.invoiceTime": "开票时间",
   "order.list.taxRate": "税率%",
   "order.list.voided": "已作废",
   "order.list.selectCustomer": "请选择客户",
   "order.list.selectSales": "请选择山海图销售",
   "order.list.selectManager": "请选择山海图经理",
   "order.list.uploadContract": "请上传双签合同",
   "order.list.success": "操作成功",
   "order.list.emptyServiceList": "订单服务清单不能为空",
   "order.list.inconsistentAmount": "服务总金额与订单金额不一致，请检查！",
   "order.list.none": "无",
   "order.list.details": "详情",
   "order.list.product": "产品",
   "order.list.invoiceTotalAmount": "发票总金额",
   "order.list.invoiceNumber": "发票号",
   "order.list.paymentProgress": "收款进度%",
   "order.list.paymentName": "付款名称",
   "order.list.paymentAccount": "付款账户",
   "order.list.exchangeAmount": "换汇金额",
   "order.list.taxes": "税金",
   "order.list.excludingTax": "金额(不含税)",
   "order.list.createWeeklyReport": "创建周报",
   "order.list.confirmOperation": "确定执行该操作吗？",
   "order.list.complete": "完成",
   "order.list.handleNodeFirst": "请先办理节点",
   "order.list.estimatedTime": "预计时间",
   "order.list.reminderDate": "催办日期",
   "order.list.reminderLevel": "催办等级",
   "order.list.selectReminderLevel": "请选择催办等级",
   "order.list.enterServiceName": "请输入服务名称",
   "order.list.selectServiceName": "请选择服务",
   "order.list.processStatus": "流程状态",
   "order.list.export": "导出",
   "order.list.reminderTime": "催办时间",
   "order.list.serviceProcessName": "服务流程名称",
   "order.list.reminderContent": "催办内容",
   "order.list.serviceEstimatedCompletionTime": "服务预计完成日期",

   "order.list.uncertain": "不确定",
   "order.list.invoiceCollection": "开票收款",
   "order.list.saveCurrentProcessFirst": "请先保存当前新增的流程",
   "order.list.completeProcessInformation": "请完善办理流程信息",
   "order.list.fillInProcessorInformation": "请填写办理负责人信息",
   "order.list.selectProcessEstimatedTime": "请选择办理流程预计时间",
   "order.list.selectProcessAttribute": "请选择办理流程属性",
   "order.list.saveSuccess": "保存成功",
   "order.list.notPass": "不通过",
   "order.list.pass": "通过",
   "order.list.selectOrderProcessChecker": "选择订单流程配置检查人",
   "order.list.confirm": "确认",
   "order.list.checker": "检查人",
   "order.list.checkOpinion": "检查意见",
   "order.list.secondCheckUser": "二次检查人",
   "order.list.enterCheckOpinion": "请输入检查意见",
   "order.list.selectChecker": "请选择检查人",
   "order.list.saveCurrentTaskFirst": "请先保存当前新增的任务",
   "order.list.selectNode": "请选择节点",
   "order.list.contractRegistrationDate": "合同登记日期",
   "order.list.serviceName": "服务名称",
   "order.list.documentType": "文档类型",
   "order.list.selectDocumentType": "请选择文档类型",
   "order.list.uploadFile": "上传文件",
   "order.list.download": "下载",
   "order.list.confirmDelete": "确定删除吗？",
   "order.list.confirmDelete.all": "确定删除全部吗？",
   "order.list.documentDescription": "文档描述",
   "order.list.uploadTime": "上传时间",
   "order.list.uploadSuccess": "上传成功",

   "order.list.process2": "流程",
   "order.list.processName": "流程名称",
   "order.list.enterProcessName": "请输入流程名称",
   "order.list.workingDays": "工期(工作日)",
   "order.list.enterWorkingDays": "请输入工期",
   "order.list.processingRole": "办理角色",
   "order.list.selectProcessingRole": "请选择办理角色",
   "order.list.processor2": "处理人",
   "order.list.processDescription": "流程说明",
   "order.list.customerVisibility": "客户可见性",
   "order.list.private": "私有",
   "order.list.public": "公开",
   "order.list.customerPrompt": "提示客户",
   "order.list.promptDescription": "提示说明",
   "order.list.selectAtLeastOneProcessor": "请至少选择一位处理人",
   "order.list.completeProcessorInformation": "请完善处理人信息",
   "order.list.invalidEmail": "邮箱有误",
   "order.list.enterProcess": "请输入流程",
   "order.list.selectCustomerVisibility": "请选择客户可见性",
   "order.list.enterWorkingDaysNumeric": "请输入工期(工作日)",
   "order.list.enterProcessDescription": "请输入流程说明",
   "order.list.notInSelectedProcessingRole": "未在所选择的办理角色当中",
   "order.list.selectCompanyOrCustomer": "选择公司/客户",
   "order.list.selectCompany": "选择公司",
   "order.list.enterCompanyNameCustomerNameEmail": "请输入公司名称，客户名称，注册邮箱",
   "order.list.favorite": "收藏",
   "order.list.enterFavoriteName": "请输入收藏名",
   "order.list.taskName": "任务名",
   "order.list.addProcess": "新增流程",
   "order.list.pushSort": "推动排序",
   "order.list.fixedNode": "固定节点",
   "order.list.custom": "自定义",
   "order.list.role": "角色",
   "order.list.attribute": "属性",
   "order.list.completeAddProcessName": "请完善新增流程名称",
   "order.list.saveOrCancelCustomProcessFirst": "请先保存或取消自定义流程",
   "order.list.selectTime": "选择时间",
   "order.list.selectAttribute": "请选择属性",
   "order.list.configureSubProcess": "配置子流程",
   "order.list.processingProcess": "办理流程",
   "order.list.processingTask": "办理任务",
   "order.list.myFavoriteTasks": "我的收藏任务",
   "order.list.addTask": "新增任务",
   "order.list.task": "任务",
   "order.list.preTask": "前置任务",
   "order.list.genericTaskFillSuccess": "通用任务回填成功",
   "order.list.genericTaskNotConfigured": "该通用任务没有配置流程，请完善流程信息",
   "order.list.selectSameTypeFavoriteEntry": "请选择同类型的收藏条目进行回填",
   "order.list.favoriteTaskFillSuccess": "收藏任务回填成功",
   "order.list.favoriteNotConfigured": "该收藏没有配置流程，请完善流程信息",
   "order.list.enterTaskName": "请输入任务名称",
   "order.list.taskNameNotEmptySpaces": "任务名称不允许输入纯空格，且第一个字符不为空格",
   "order.list.selectResponsiblePersonOr": "请选择负责人",
   "order.list.or": "或",
   "order.list.selectPreProcessingTask": "请选择前置办理任务，可多选",
   "order.list.checkStatus": "检查状态",
   "order.list.notChecked": "未检查",
   "order.list.enter": "请输入",
   "order.list.miaos": "描述",
   "order.list.qtxscmc": "请填写收藏名称",
   "order.list.qsrzdylcm": "输入自定义流程名",
   "order.list.tyrw": "通用任务",
   "order.list.cklc": "查看流程",
   "order.list.xzzbht": "选择周报合同",
   "order.list.zbjl": "周报记录",
   "order.list.kh": "客户",
   "order.list.qxzht": "请选择合同",
   "order.list.qxztykhcjzb": "请选择同一客户创建周报",
   "order.list.tjdy": "添加订阅",
   "order.list.cjr": "创建人",
   "order.list.cjrq": "创建日期",
   "order.list.qxzkpskjd": "请选择开票收款节点",
   "order.list.taskNumber": "任务编号",
   "order.list.enterProcessNumber": "请输入流程编号",
   "order.list.taskStatus": "任务状态",
   "order.list.disabled": "已停用",
   "order.list.enabled": "已启用",
   "order.list.approvalTemplateNumber": "审批单模版编号",
   "order.list.serviceProcess": "服务流程",
   "order.list.Ordercreationdate": "订单创建日期",
   "order.list.Contractregistrationdate": "合同登记日",
   "order.list.contractamount": "合同金额",
   "order.list.Handlingpersonnelsetup": "办理人员设置",

   "order.list.basicInformation": "基本信息",
   "order.list.assignOrder": "分配订单",
   "order.list.contractAmountIncludingTax": "合同金额(含税)",
   "order.list.pleaseSelect": "请选择",
   "order.list.contractBelongingCountry": "合同服务归属国家",
   "order.list.orderOnCountry": "订单产品归属国家",

   "order.list.contractSigningCountry": "请选择合签同署国家",
   "order.list.contractVATRate": "合同增值税税率",
   "order.list.PlesecontractVATRate": "请输入合同增值税税率",
   "order.list.customerChineseCompanyName": "客户中文公司名",
   "order.list.customerCode": "客户编码",
   "order.list.contractScannedCopy": "双签合同",
   "order.list.serviceInformation": "服务信息",
   "order.list.nextStep": "下一步",
   "order.list.serviceNumber": "服务编号",
   "order.list.servicePrice": "服务价格",
   "order.list.serviceCategory": "服务分类",
   "order.list.FPprojectManager": "分配项目经理",
   "order.list.contractInfo": "合同信息",
   "order.list.countryRegion": "国家/地区",
   "order.list.qsrbllcmc": "请输入办理流程名称",
   "order.list.qsrblfzr": "请输入办理负责人",
   "order.list.qsryjsj": "请输入预计时间",
   "order.list.qsrzdyrw": "输入自定义任务",
   "order.list.fwm": "服务名",
   "order.list.wdmc": "文档名称",
   "order.list.rwmc": "任务名称",
   "order.list.inputCountry": "请输入国家",
   "order.list.accountsReceivable": "应收账款",
   "order.list.pendingPayment": "待收款",
   "order.list.performance": "业绩",
   "order.list.brand": "品牌",
   "order.list.all": "全部",
   "order.list.hide2": "隐藏",
   "order.list.wgj": "未跟进",
   "order.list.ygj": "已跟进",
   "order.list.enterCollectionName": "请输入收款名称",
   "order.list.collectionVoucher": "收款凭证",
   "order.list.collectionAccount": "收款账户",
   "order.list.selectCollectionAccount": "请选择收款账户",
   "order.list.ticketNumber": "票号",
   "order.list.selectTicketNumber": "请选择票号",
   "order.list.enterTaxRate": "请输入税率",
   "order.list.apportionService": "分摊服务",
   "order.list.selectService": "请选择服务",
   "order.list.apportionInvoiceAmount": "分摊发票金额",
   "order.list.canApportion": "可分摊",
   "order.list.accountsReceivableAmount": "应收款金额",
   "order.list.actualReceivedAmount": "实收金额",
   "order.list.collectionTime": "收款时间",
   "order.list.selectCollectionTime": "请选择收款时间",
   "order.list.enterPaymentName": "请输入付款名称",
   "order.list.selectCollectionVoucher": "请选择收款凭证",
   "order.list.selectAccount": "请选择账户",
   "order.list.enterActualReceivedAmount": "请输入实收金额",
   "order.list.sameServiceCannotApportionMultipleTimes": "同一服务不能分摊多次",
   "order.list.actualReceivedAmountCannotExceedInvoiceAmount": "实收金额不能大于开票金额",

   "order.list.skjl": "收款记录",
   "order.list.qsrskf": "请输入收款方",
   "order.list.qxzfksj": "请选择付款时间",
   "order.list.isShared": "是否共享",
   "order.list.notShared": "不共享",
   "order.list.shared": "共享",
   "order.list.enterDocumentName": "请输入文档名称",
   "order.list.enterDocumentSource": "请输入文档来源",
   "order.list.invoiceRecord": "开票记录",
   "order.list.invoiceType": "发票类型",
   "order.list.enterInvoiceNumber": "请输入发票号",
   "order.list.selectInvoiceTime": "请选择开票时间",
   "order.list.selectInvoiceType": "请选择发票类型",
   "order.list.paymentRecord": "付款记录",
   "order.list.payee": "收款方",
   "order.list.paymentVoucher": "付款凭证",
   "order.list.refreshExchangeRate": "重新获取汇率",
   "order.list.enterPaymentAmount": "付款金额",
   "order.list.enterExchangeRate": "请输入汇率",
   "order.list.selectPaymentVoucher": "请选择付款凭证",
   "order.list.productCategory": "商品分类",
   "order.list.selectProductCategory": "请选择商品分类",
   "order.list.specification": "规格",
   "order.list.originalUnitPrice": "原单价",
   "order.list.unitReceivableAmount": "单件应收金额(不含税)",
   "order.list.eachDiscount": "每件优惠",
   "order.list.taxInclusiveTotalPrice": "含税总价",
   "order.list.selectProduct": "请选择产品",
   "order.list.enterQuantity": "请输入数量",
   "order.list.enterOriginalUnitPrice": "请输入原单价",
   "order.list.enterReceivableAmount": "请输入应收金额",
   "order.list.enterEachDiscount": "请输入每件优惠",
   "order.list.noConfiguredNodeForThisService": "此服务没有配置节点，拒绝添加",
   "order.list.selectSpecification": "请选择规格",
   "order.list.enterCompanyName": "公司名称",
   "order.list.enterCompanyName2": "请输入公司名称",
   "order.list.syncInProgress": "同步中",
   "order.list.sync": "同步",
   "order.list.enterCustomerName": "请输入客户名",
   "order.list.chinaCompanyName": "公司名称",
   "order.list.overseasCompanyName": "海外公司名称",
   "order.list.country": "国家",
   "order.list.syncSuccess": "同步成功",
   "order.list.fileDownload": "文件下载",
   "order.list.enterNodeName": "节点名",
   "order.list.enterNodeDescription": "节点描述",
   "order.list.processingTimeInDays": "办理时长(工作日)",
   "order.list.enterProcessingTime": "请输入办理时长",
   "order.list.processingDate": "办理日期",
   "order.list.selectProcessingDate": "请选择办理日期",
   "order.list.enterProgressDescription": "请输入进展说明",
   "order.list.sendNotification": "发送通知",
   "order.list.send": "发送",
   "order.list.enterNode": "请输入节点",
   "order.list.enterWorkingTime": "请输入工作时长",
   "order.list.selectProcessingTime": "请选择办理时间",
   "order.list.pushNotificationInformation": "推送通知信息",
   "order.list.channel": "渠道",
   "order.list.templateNotSelected": "模版尚未选择，请选择模版后再进行预览",
   "order.list.preview": "预览",
   "order.list.enterTemplateName": "请输入模板名",
   "order.list.selectParameters": "请选择参数",
   "order.list.options": "选项",
   "order.list.miniProgramNotificationContent": "小程序通知内容",
   "order.list.completeParameters": "请补全参数",
   "order.list.enterCustomVariableValue": "请输入自定义变量值",
   "order.list.totalAmount": "合计总额",
   "order.list.valueAddedTax": "增值税",
   "order.list.totalInclusiveAmount": "合计(含税总额)",
   "order.list.productUnitPrice": "产品单价",
   "order.list.unitDiscount": "单件优惠",
   "order.list.enterNodeName2": "请输入节点名",
   "order.list.enterNodeDescription2": "请输入节点描述",
   "order.list.parameter": "参数",
   "order.list.xzkh": "选择客户",
   "order.list.billingAmountWithTax": "开票金额(含税)",
   "order.list.billingAmount": "开票金额",
   "order.list.receivableAmount": "待收金额",
   "order.list.receivableBillingAmount": "待收开票额",
   "order.list.unreceivedAmount": "未回款金额",
   "order.list.receivedAmount": "回款金额",
   "order.list.fileDownloadFailed": "文件下载失败",
   "order.list.hksc": "回款时长",
   "order.list.yhkje": "已回款金额",
   "order.list.hkbl": "回款比例",
   "order.list.contractManager": "合同负责人",
   "order.list.checked": "已勾选",
   "order.list.selectedServices": "个服务",
   "order.list.selectedCountry": "请选择国家",
   "order.list.selectedServicesRequired": "请至少选择一个服务",
   "order.list.orderCountry": "订单国家",
   "order.list.paymentMethod": "付款方式",
   "order.list.paymentMethodRequired": "请选择付款方式",
   "order.list.createOrder": "创建订单",
   "order.list.orderCreated": "已创建",
   "order.list.processing": "办理中",
   "order.list.closed": "已关闭",
   "order.list.PleaseAssignOrder": "请先分配订单",
   "order.list.PleaseAssigncontractlevel": "请选择合同等级",
   "order.list.Contractlevel": "合同等级",
   "order.list.orderCreatedSuccessfully": "创建成功",
   "order.list.createSuccess": "创建成功，如有新增订单需求请继续新增",
   "order.list.backToContractList": "回到合同列表",
   "order.list.Continueadd": "继续新增",
   "order.list.actualCompletionDate": "实际完成日期",
   "order.list.actualCompletionTime": "实际完成时间",
   "order.list.fileManagement": "文件管理",
   "order.list.startTime": "开始时间",
   "order.list.completionTime": "完成时间",
   "order.list.noPreTask": "无前置任务",
   "order.list.atLeastOnePrerequisiteTask": "请至少选择一个前置任务",
   "order.list.prerequisiteTask": "请选择前置任务",
   "order.list.notificationcustomer": "通知客户",
   "order.list.reminder": "提醒客户",
   "order.list.promptDesc": "提醒内容",
   "order.list.on": "是",
   "order.list.off": "否",
   "order.list.termination": "终止",
   "order.list.instruction": "办理说明",
   "order.list.instruction2": "请输入办理说明",
   "order.list.PM.rate": "项目经理评分",
   "order.list.PM.completed": "已完成",
   "order.list.PM.uncompleted": "未完成",
   "order.list.PM.evalItems": "工作项",
   "order.list.PM.score": "评分",
   "order.list.PM.scoreDescribe": "评分说明",
   "order.list.PM.scoreDescribe.placeholder": "请评分",
   "order.list.PM.scoreDescribe.noedit": "评分不可修改",
   "order.list.PM.scoreDescribe.completed": "请完成项目经理评分",
   "order.list.PM.scoreDescribe.default": "等级无需项目启动会，自动默认得一分。",
   "order.list.PM.scoreDescribe.default2": "未上传项目启动会，自动默认得零分",
   "order.list.PM.score.nosave": "评分修改未保存！点击确定将不会保留您的更改，是否确定继续？",
   "order.list.node.complete.tip": "您确定节点完成了吗？",
   "order.list.node.allcomplete.tip": "您确定服务完成了吗？",
   "order.list.PM.satisfied": "优秀",
   "order.list.PM.average": "合格",
   "order.list.PM.notSatisfied": "待提升",
   "order.list.PM.totalScore": "总分",
   "order.list.PM.getScore": "，得分",
   "order.list.PM.points": "分",
   "order.list.wait": "等待",
   "order.list.plannedDuration": "承诺工期（工作日）",
   "order.list.need": "需要",
   "order.list.NOneed": "不需要",
   "order.list.processingRecord": "处理记录",
   "order.list.expected_restart_time": "预计重启时间",
   "order.list.returned": "退回",
   "order.list.suspended": "挂起",
   "order.list.myVariableKey": "重启任务",
   "order.list.returnExplanation": "退回说明",
   "order.list.PleasereturnExplanation": "请输入退回说明",
   "order.list.onlyProjectManagerCanSuspend": "只有该订单的项目经理才能挂起",
   "order.list.confirmExecute": "确定执行该操作吗",
   "order.list.expectedRestartDate": "预计重启日期",
   "order.list.selectExpectedRestartDate": "请选择预计重启日期",
   "order.list.suspendExplanation": "挂起说明",
   "order.list.enterSuspendExplanation": "请输入挂起说明",
   "order.list.restart": "重启",
   "order.list.start": "开始",
   "order.list.restartSuccess": "重启成功",
   "order.list.returnSuccess": "退回成功",
   "order.list.suspendSuccess": "挂起成功",
   "order.list.contractRegistrationService": "合同登记服务",
   "order.list.selectContractRegistrationService": "请选择合同登记服务",
   "order.list.serviceQuantity": "可办理服务数量",
   "order.list.enterTaskNameCN": "请输入任务名称(中文)",
   "order.list.enterTaskNameLocal": "请输入任务名称(本地)",
   "order.list.taskNameLocal": "任务名称(本地)",
   "order.list.taskNameCN": "任务名称(中文)",
   "order.list.enterName": "请输入名称",
   "order.list.noNodeConfigured": "此服务没有配置节点,拒绝添加",
   "order.list.serviceQuantityExceeded": "已超出可办理服务数量",
   "order.list.serviceQuantityCannotBeZero": "可办理服务数量不能为0",
   "order.list.handlerInformation": "处理人信息",
   "order.list.projectManagerAcceptanceHandlerLimit": "项目经理验收处理人只允许1人",
   "order.list.salesInvoiceHandlerLimit": "销售开票处理人只允许1人",
   "order.list.pleaseAdd": "请添加",
   "order.list.taskFlow": "任务流程",
   "order.list.restoreDefault": "恢复默认/更新任务节点",
   "order.list.sort": "排序",
   "order.list.viewTask": "查看任务",
   "order.list.foxmessage": "检查信息",
   "order.list.retask": "重新分解任务",
   "order.list.confirmtask": "确认任务",
   "order.list.backed": "被退回",

   "order.list.khbmyw": "客户编号有误",
   "order.list.gldd": "关联订单",
   "order.list.fwdh": "服务单价",
   "order.list.wfzjbhs": "服务总价(不含税)",

   "order.evaluate.evaluationDate": "评价日期",
   "order.evaluate.evaluationLevel": "评价等级",
   "order.evaluate.selectEvaluationLevel": "请选择评价等级",
   "order.evaluate.followUpStatus": "跟进状态",
   "order.evaluate.selectFollowUpStatus": "请选择跟进状态",
   "order.evaluate.myParticipation": "我参与的",
   "order.evaluate.hideEmptyReviews": "隐藏无内容评价",
   "order.evaluate.followUp": "跟进",
   "order.evaluate.negativeReview": "差评",
   "order.evaluate.neutralReview": "中评",
   "order.evaluate.positiveReview": "好评",
   "order.evaluate.evaluationContent": "评价内容",

   "order.evaluate.Nocontractmanagerassigned": "未设置合同负责人",
   "order.evaluate.Assignthisprojectmanager": "将此项目经理设为合同负责人",
   "order.evaluate.checkout1": "合同服务和跨国服务不能同时选择",
   "order.evaluate.checkout2": "选择跨国服务时不能选择合同国家",
   "order.evaluate.checkout3": "当前选择国家和服务不匹配",
   "order.evaluate.selecttheassignedcontract": "请先选择分配的合同",

   "order.evaluate.task": "重新分解：可以重新分配订单任务，此时其他关联订单无法选择此订单下的任务作为前置任务",
   "order.evaluate.task2": "任务确认后，不可删除、新增任务，此时订单任务可作为其他关联订单的前置任务",
   "order.evaluate.pleasename": "请输入用户名",
   "order.evaluate.ClickDragtoUpload": "点击/拖动上传",
   "order.list.Checking": "检查中",
   "order.evaluate.orderCount": "订单数量",
   "order.evaluate.productCount": "服务数量",
   "order.list.customerNameSX": "客户名",
   "order.list.CM": "合同负责人",
   "order.list.CMAll": "合同负责人",
   "order.list.tbcrmsj": "同步CRM数据",
   "order.list.tbcrmsjTips": "点击后开始更新CRM最新数据，2分钟后更新完成",
   "order.list.xzyh": "选择用户",
   "order.list.unitDealPrice": "单件成交价",
   "order.list.fixAPrice": "定价",
   "order.list.includingTax": "金额(含税)",
   "order.list.tips1": "{param}说明",
   "order.list.tips2": "请输入{param}说明",
   "order.list.voidDescription": "作废说明",
   "order.list.closingDescription": "关闭说明",

   "order.workHandover": "工作交接",
   "order.handoverHistory": "交接历史",
   "order.transferContractOwner": "转交合同负责人",
   "order.transferProjectManager": "转交项目经理",
   "order.transferHandler": "转交处理人",
   "order.confirmContractOwnerAsHandler": "此交接人是合同负责人，确认后合同负责人也会修改",
   "order.operationDate": "操作日期",
   "order.action": "动作",
   "order.handoverPerson": "交接人",
   "order.successor": "接替人",
   "order.operationBatchNumber": "操作批次编号",
   "order.operator": "操作人",
   "order.projectManagerHandover": "项目经理交接",
   "order.handlerHandover": "办理人交接",
   "order.contractOwnerHandover": "合同负责人交接",
   "order.selectHandoverAction": "请选择交接动作",
   "order.selectHandoverPerson": "请选择交接人",
   "order.selectSuccessor": "请选择接替人",
   "order.transferred": "请先勾选要转交的订单",
   "order.list.Time": "时间",
   "order.list.Task": "任务",
   "order.list.Time2": "请选择时间",
   "order.list.Confirm": "确定",
   "order.list.Add": "增加条件组",
   "order.list.change": "变更",
   "order.list.noorderchange": "非合同分配而来的订单不支持变更",
   "order.list.currenttask": "当前任务没有设置办理服务，不能作为前置",
   "order.list.modified": "已完成的任务不能执行变更操作",
   "order.list.modified2": "已终止的任务不能执行变更操作",
   "order.list.processTask": "请在钉钉上处理{taskName}任务",
   "order.list.Requiredinformation": "所需资料",
   "order.list.Processingdocuments": "办理文件",
   "order.list.Deliverdocuments": "交付资料",
   "order.list.Trash": "回收站",
   "order.list.Viewinstructions": "查看说明",
   "order.list.Uploader": "上传人",
   "order.list.Uploadtime": "上传时间",
   "order.list.Upload": "上传",
   "order.list.Listofdocuments": "资料清单",
   "order.list.Adddata": "新增资料",
   "order.list.Dataname": "资料名称",
   "order.list.Pleaseselectdata": "请选择资料",
   "order.list.Pleaseselectdataname": "请选择资料名称",
   "order.list.Content": "内容",
   "order.list.Pleaseentercontent": "请输入内容",
   "order.list.wanttorestore": "确定恢复吗",
   "order.list.wanttorestore.all": "确定恢复全部吗",
   "order.list.Restore": "恢复",
   "order.list.Title": "标题",
   "order.list.retishi": "确定要使用新的资料配置吗？确定后将会清空回收站记录!",
   "order.list.Description": "文件说明",
   "order.list.Fillperson": "填写人",
   "order.list.Filltime": "填写时间",
   "order.list.heretoupload": "点击或将文件拖拽到这里上传",
   "order.list.fileFormat": "文件格式",
   "order.list.DataManagement": "资料管理",
   "order.list.configuration": "请先删除所有资料，才能使用重置按钮获取最新的资料配置",
   "order.list.notsupportenteringthedata": "该任务类型暂不支持进入资料管理模块",
   "order.list.suspendtype": "挂起类型",
   "order.list.selectSuspendtype": "请选择挂起类型",
   "order.list.attachment": "项目启动会附件",
   'order.list.retract': '收起',
   "order.list.expand": '展开',
   "order.list.contractchanged": '合同等级已变更，将回退到未检查状态重新检查订单',
   "order.list.hint": '提示',
   "order.list.BeijingTime": '北京时间',
   "order.list.possible": '请安排销售尽快和客户联系',
   "order.list.lb": '仅内部可见',
   "order.list.khkj": '客户可见',
   "order.list.projectkickoffmeetingdocument": '请上传项目启动会文件',
   "order.list.Negotiable": '面议',
   "order.list.ServiceTerminationNotice": '服务作废说明',
   "order.list.ApprovalNumber": '审批编号',
   "order.list.AcceptanceCondition": '验收情况',
   "order.list.DingTalkapprovalnumber": '请输入合同变更审批通过的钉钉审批编号',
   "order.list.Filteritem": '筛选项',
   "order.list.Columnpresentation": '列展示',
   "order.list.Displaycolumn": '显示列',
   "order.list.Originaldate": '原日期',
   "order.list.Changedate": '更改日期',
   "order.list.estimatedCompletionDate2": '申请修改预计完成日期',
   "order.list.Modificationrecord": '修改记录',
   "order.list.back": '返回',
   "order.list.Applicationdate": '申请日期',
   "order.list.DingTalkprocessnumber": '钉钉流程编号',
   "order.list.searchforservices": '请输入关键字搜索服务',
   "order.list.etc": '预计完成日期',
   "order.list.etcSub": '预计完成日期',
   "order.list.selectchangedate": '请选择更改日期',
   "order.list.onetask": '请至少选择一个任务',
   "order.list.ChineseSupport": '中文客服',
   "order.list.aftersum": '提交后请到钉钉中补充申请材料并提交订单流程申请！',
   "order.list.OverdueOrder": '超期订单',
   "order.list.RiskOrder": '风险订单',
   "order.list.RiskService": '风险服务',
   "order.list.OverdueService": '超期服务',
   "order.transferChineseSupport": "转交中文客服",
   "order.transferChineset": "中文客服交接",
   "order.list.node.complete": '节点完成',
   "order.list.continue.process": '继续办理',
   "order.list.all.complete": '服务完成',
   "order.list.recall": '撤回',
   "order.list.pleaseContact": '请联系{name}退回',
   "order.list.systemcheck": '系统检查',
   "order.list.similarnonreasonable": '存在同时启动的情况，疑似不合理',
   "order.list.receipttask": '收款任务',
   "order.list.continueSubmit": '继续提交',
   "order.list.backEdit": '返回编辑',
   "order.list.month": '月份',
   "order.list.quarter": '季度',
   "order.list.Year": '年份',
   "order.list.modifyEtc": '修改预计完成日期',
   "order.list.customerVisible": '客户可见',
   "order.list.customerVisibleOpen": '开',
   "order.list.customerVisibleClose": '关',
   "order.list.departmentId": '部门',
   "order.list.timelyAllocationOrder": '分配不及时订单',
   "order.list.nodeHandler": '节点处理人',
   "order.list.copyContent": '复制内容',
   "order.list.serviceNum": '服务数量',
   "order.list.copyNum": '复制数量',
   "order.copy.maxTip": "最大可复制",
   "order.copy.unit": "个",
   "order.copy.remainingTotal": "剩余服务总数",
   "order.copy.noRemainingService": "该产品没有剩余服务",
   "order.list.orderAllocation": '订单分配情况',
   "order.list.unreasonable": '不及时',
   "order.list.attachment2": '附件',
   "order.list.Pleaseuploadattachment": '请上传附件',
   "order.list.suspendReminder": '挂起提醒',
   "order.list.day": '天',
   "order.list.month2": '月',
   "order.list.nodeSuspend": '节点挂起{SuspendDay}天',
   "order.list.timelyAllocationOrder2": '分配不及时',
   "order.list.suspendTimeLimit": '挂起提醒时间不能为空',
   "order.list.viewAttachment": '查看附件',
   "order.list.expectedRestartTime": '预计启动时间不能小于当前时间',
   "order.list.allTaskCompleted": '合同全部服务完成',
   "order.list.editTask": '编辑任务',
   "order.list.taskNameCNRequired": '任务名称(中文)不能为空',
   "order.list.checkDetails": '二次检查信息',
   "order.list.allServiceCompleted": '该合同下的所有服务完成后开始收款',
   "order.aiTask.title": "任务",
   "order.aiTask.result": "结果",
   "order.aiTask.aiRecognize": "AI识别",
   "order.aiTask.reRecognize": "重新识别",
   "order.aiTask.errorRetry": "请重试",
   "order.aiTask.confirm": "确认无误",
   "order.aiTask.completed": "已完成",
   "order.aiTask.uncompleted": "未完成",
   "order.aiTask.pendingConfirmation": "待确认",
   "order.aiTask.lastProcessTime": "上次处理时间",
   "order.aiTask.aiRecognizeError": "AI识别异常，请稍后重试",
   "order.aiTask.aiRecognizeTimeout": "AI分析超时，请稍后重试",
   "order.aiTask.tips": '提示',
   "order.aiTask.confirmContent": "请确认数据是否正确？",
   "order.aiTask.loading": "AI任务加载中，请稍后再试",
   "order.aiTask.required": "请先完成任务：",
   "order.aiTask.multipleFiles": "识别到多个文件",
   "order.aiTask.noFile": "没有识别到对应的文件",
   "order.list.editEtc": "编辑预计完成日期",
   "order.list.inAdvanceFinish": "提前完成",
   "order.aiTask.notRecognize": "部分数据未识别到，请人工确认",
   "order.aiTask.confirmTip": "以下为AI识别内容，请确认，若无问题，请点击确认无误",

   "order.list.tips3": "请输入订单编号",
   "order.list.tips4": "订单编号与选中订单不一致",
   "order.list.tips5": "订单作废后，该订单下所有服务全部作废，请谨慎操作",
   "order.list.tips6": "订单关闭后，该订单下未完成服务全部停止执行，请谨慎操作",
   "order.list.tips7": "重新分配订单后，该订单下所有服务全部作废，请谨慎操作",
   "order.aiTask.cancel": "取消",
   "order.aiTask.save": "保存",
   "order.aiTask.manualModify": "人工修改",
   "order.aiTask.confirmDiscard": "确定丢弃吗？",
   "order.aiTask.discard": "丢弃",
   "order.aiTask.handler": "处理人",

   "order.list.copyCustomerData": "复制客户资料",
   "order.list.customerData": "客户资料",
   "order.list.currentContract": "当前合同",
   "order.list.otherContract": "其他合同",
   "order.list.service": "服务",
   "order.list.service.placeholder": "请输入服务名或编号",
   "order.list.serviceRemark": "服务备注",
   "order.list.confirmCopy": "确认复制",
   "order.list.confirmCopyTip": "确认复制吗？",
   "order.list.copySuccess": "文件复制成功！",
   "order.list.copyFailed": "文件复制失败！",
   "order.list.copyComplete": "退出复制",
   "order.list.continueCopy": "继续复制",
   "order.list.estimatedCompletionDate.new": "预计完成日期",
   "order.list.systemFixAPrice": "系统定价",
   "order.list.receiptDataError": "收款数据异常，请及时补录",
   "order.list.isReassign": "是否重新分配订单",
   "order.list.reassignOrder": "重新分配订单",
   "order.list.tips8": "请选择是否重新分配订单",
   "order.list.yes": "是",
   "order.list.no": "否",
   "order.list.isNotifierWorkload": "业绩比例",
   "order.list.isNotifierWorkload2": "业绩比例",
   "order.list.isNotifierWorkload.yes": "已设置",
   "order.list.isNotifierWorkload.no": "未设置",
   "order.list.setRatio": "去设置",
   "order.list.performanceRatio2": "业绩比例设置",
   "order.list.setPerformanceRatio": "设置业绩比例",
   "order.list.projectStartUpConfigTip": "未上传项目启动会资料",
   "order.list.performanceRatioTip": "业绩比例未完全配置",
   "order.list.confirmSubmit": "确定要继续提交吗？",


   "payment.plan": "回款计划",
   "payment.currentProgress": "当前进度",
   "payment.plannedAmount": "计划金额",
   "payment.receivedAmount": "收款金额",
   "payment.notStarted": "未开始",
   "payment.inCollection": "收款中",
   "payment.completed": "已完成",
   "payment.cancelled": "已取消",
   "payment.indication": "示意",
   "order.list.set": "业绩设置",
   "order.list.howToSetMultiple": "如何设置多人？",
   "order.list.approved": "钉钉流程审批中",
}